export default "__VITE_ASSET__z8sFI9M3__"